import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("input", { hidden: "" }, null, -1)
const _hoisted_2 = { class: "flex gap-4" }

import {Button} from "@/components/ui/button";
  import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogFooter, DialogHeader, DialogTitle
  } from "@/components/ui/dialog";
  import {Input} from "@/components/ui/input";
  import TablesService from "@/services/tables/tables.service";
  import useEventsBus from "@/utils/eventBus";
  import {Separator} from "@/components/ui/separator";
  import {toTypedSchema} from "@vee-validate/zod";
  import * as z from "zod";
  import {useForm} from "vee-validate";
  import {computed, ref, watch} from "vue";
  import {
    FormControl,
    FormField,
    FormItem,
    FormLabel,
    FormMessage,
  } from '@/components/ui/form'
  import { CalendarDate, DateFormatter, getLocalTimeZone, parseDate, today } from '@internationalized/date'
  import { Calendar } from '@/components/ui/calendar'
  import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
  import {cn} from "@/utils/utils";
  import {Calendar as CalendarIcon, Check, ChevronsUpDown} from 'lucide-vue-next'
  import {i18n} from "@/utils/i18n";
  import {Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList} from "@/components/ui/command";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ServiceOrdersEditForm',
  props: {
    object: {},
    entity: {},
    open: { type: Boolean },
    setOpen: {}
  },
  setup(__props: any) {

  const props = __props
  const { emit } = useEventsBus();
  let users: any = [];
  let coverages: any = [];
  let serviceOrder: any = {};
  const formSchema = toTypedSchema(z.object({
    date: z.string(),
    user: z.number(),
    coverage: z.number(),
  }))
  const { handleSubmit, values, setValues } = useForm({
    validationSchema: formSchema,
  })
  const df = new DateFormatter('it-IT', {
    dateStyle: 'long',
  })
  const date = computed({
    get: () => values.date ? parseDate(values.date) : undefined,
    set: val => val,
  })
  const datePlaceholder = ref();
  const usersOpen = ref(false);
  const coveragesOpen = ref(false);

  watch(values, (newFormData) => {
    serviceOrder = newFormData;
  });

  const onSubmit = handleSubmit(async () => {
    let res;
    if (!props.object.id) {
      res = await TablesService.createRecord(serviceOrder, props.entity);
    } else {
      res = await TablesService.updateRecord(serviceOrder, props.entity);
    }
    if (res != undefined) {
      emit('update_'+props.entity, res.data);
    }
  })

  async function getUsers() {
    const res = await TablesService.getData('users')
    users = res?.data
  }

  async function getCoverages() {
    const res = await TablesService.getData('coverages')
    coverages = res?.data
  }

  watch(() => props.open, async(_, newValue) => {
    if (newValue === false) {
      await getUsers();
      await getCoverages();
      if (props.object.id) {
        await initializeForm()
      }
    }
  },{ immediate: true })

  async function initializeForm() {
    const res = await TablesService.getElementById(props.entity, props.object.id);
    if (res?.data) {
      const formValues = res.data
      const date = new Date(formValues.date);
      formValues.date = new CalendarDate(date.getFullYear(), date.getMonth(), date.getDay()).toString();
      formValues.coverage = formValues.coverage.id
      formValues.user = formValues.user.id
      setValues(formValues);
    }
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    open: props.open,
    "onUpdate:open": props.setOpen
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(DialogContent), { class: "max-w-[60vw]" }, {
        default: _withCtx(() => [
          _createVNode(_unref(DialogHeader), null, {
            default: _withCtx(() => [
              (!props.object.id)
                ? (_openBlock(), _createBlock(_unref(DialogTitle), { key: 0 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('table.add')), 1)
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_unref(DialogTitle), { key: 1 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('table.edit')), 1)
                    ]),
                    _: 1
                  })),
              _createElementVNode("form", {
                onSubmit: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args))),
                class: "mt-3"
              }, [
                _createVNode(_unref(FormField), { name: "date" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(FormItem), { class: "flex flex-col" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(FormLabel), null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('column.date')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(Popover), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(PopoverTrigger), { "as-child": "" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(FormControl), null, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(Button), {
                                      variant: "outline",
                                      class: _normalizeClass(_unref(cn)(
                  'w-full ps-3 text-start font-normal',
                  !date.value && 'text-muted-foreground',
                ))
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", null, _toDisplayString(date.value ? _unref(df).format(new Date(date.value as any)) : _unref(i18n).global.t('column.date')), 1),
                                        _createVNode(_unref(CalendarIcon), { class: "ms-auto h-4 w-4 opacity-50" })
                                      ]),
                                      _: 1
                                    }, 8, ["class"]),
                                    _hoisted_1
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(PopoverContent), { class: "w-auto p-0" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Calendar), {
                                  placeholder: datePlaceholder.value,
                                  "onUpdate:placeholder": _cache[0] || (_cache[0] = ($event: any) => ((datePlaceholder).value = $event)),
                                  modelValue: date.value,
                                  "onUpdate:modelValue": [
                                    _cache[1] || (_cache[1] = ($event: any) => ((date).value = $event)),
                                    _cache[2] || (_cache[2] = (v) => {
                if (v) {
                  _unref(setValues)({
                    date: v.toString(),
                  })
                }
                else {
                  _unref(setValues)({
                    date: '',
                  })
                }

              })
                                  ],
                                  "calendar-label": _unref(i18n).global.t('column.date'),
                                  "initial-focus": "",
                                  "min-value": new (_unref(CalendarDate))(2000, 1, 1)
                                }, null, 8, ["placeholder", "modelValue", "calendar-label", "min-value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(FormMessage))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Separator), { class: "my-1" }),
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_unref(FormField), { name: "user" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(FormItem), { class: "flex flex-col w-full" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(FormLabel), null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('column.user')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(Popover), {
                            open: usersOpen.value,
                            "onUpdate:open": _cache[3] || (_cache[3] = ($event: any) => ((usersOpen).value = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(PopoverTrigger), { "as-child": "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(FormControl), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(Button), {
                                        variant: "outline",
                                        role: "combobox",
                                        class: _normalizeClass(_unref(cn)('w-full justify-between', !_unref(values).user && 'text-muted-foreground'))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_unref(values).user ? _unref(users).find(
                          (user) => user.id === _unref(values).user,
                      )?.name + ' ' + _unref(users).find(
                          (user) => user.id === _unref(values).user,
                      )?.surname : _unref(i18n).global.t('table.select')) + " ", 1),
                                          _createVNode(_unref(ChevronsUpDown), { class: "ml-2 h-4 w-4 shrink-0 opacity-50" })
                                        ]),
                                        _: 1
                                      }, 8, ["class"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_unref(PopoverContent), { class: "w-[45vw] p-0" }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(Command), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CommandInput), {
                                        placeholder: _ctx.$t('table.search')
                                      }, null, 8, ["placeholder"]),
                                      _createVNode(_unref(CommandEmpty), null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t('table.no_result')), 1)
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_unref(CommandList), null, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(CommandGroup), null, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(users), (user) => {
                                                return (_openBlock(), _createBlock(_unref(CommandItem), {
                                                  key: user.id,
                                                  value: user.id,
                                                  onSelect: () => {
                              _unref(setValues)({
                                user: user.id,
                              })
                              usersOpen.value = false
                            }
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_unref(Check), {
                                                      class: _normalizeClass(_unref(cn)('mr-2 h-4 w-4', user.id === _unref(values).user ? 'opacity-100' : 'opacity-0'))
                                                    }, null, 8, ["class"]),
                                                    _createTextVNode(" " + _toDisplayString(user.name) + " " + _toDisplayString(user.surname), 1)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["value", "onSelect"]))
                                              }), 128))
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["open"]),
                          _createVNode(_unref(FormMessage))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(FormField), { name: "coverage" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(FormItem), { class: "flex flex-col w-full" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(FormLabel), null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('column.coverage')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(Popover), {
                            open: coveragesOpen.value,
                            "onUpdate:open": _cache[4] || (_cache[4] = ($event: any) => ((coveragesOpen).value = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(PopoverTrigger), { "as-child": "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(FormControl), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(Button), {
                                        variant: "outline",
                                        role: "combobox",
                                        class: _normalizeClass(_unref(cn)('w-full justify-between', !_unref(values).coverage && 'text-muted-foreground'))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_unref(values).coverage ? _unref(coverages).find(
                          (coverage) => coverage.id === _unref(values).coverage,
                      )?.name : _unref(i18n).global.t('table.select')) + " ", 1),
                                          _createVNode(_unref(ChevronsUpDown), { class: "ml-2 h-4 w-4 shrink-0 opacity-50" })
                                        ]),
                                        _: 1
                                      }, 8, ["class"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_unref(PopoverContent), { class: "w-[45vw] p-0" }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(Command), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CommandInput), {
                                        placeholder: _ctx.$t('table.search')
                                      }, null, 8, ["placeholder"]),
                                      _createVNode(_unref(CommandEmpty), null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t('table.no_result')), 1)
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_unref(CommandList), null, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(CommandGroup), null, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(coverages), (coverage) => {
                                                return (_openBlock(), _createBlock(_unref(CommandItem), {
                                                  key: coverage.id,
                                                  value: coverage.id,
                                                  onSelect: () => {
                              _unref(setValues)({
                                coverage: coverage.id,
                              })
                              coveragesOpen.value = false
                            }
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_unref(Check), {
                                                      class: _normalizeClass(_unref(cn)('mr-2 h-4 w-4', coverage.id === _unref(values).coverage ? 'opacity-100' : 'opacity-0'))
                                                    }, null, 8, ["class"]),
                                                    _createTextVNode(" " + _toDisplayString(coverage.name), 1)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["value", "onSelect"]))
                                              }), 128))
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["open"]),
                          _createVNode(_unref(FormMessage))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_unref(DialogFooter), { class: "mt-6" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(DialogClose), { "as-child": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Button), {
                          type: "button",
                          variant: "secondary"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('table.cancel')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Button), { type: "submit" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('table.confirm')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ], 32)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["open", "onUpdate:open"]))
}
}

})